import { isNil } from "lodash-es";
import { Show } from "solid-js";
import { Portal } from "solid-js/web";
import { ADMIN_STATE, quick } from "~/utils/app_state";
import { clsx } from "~/utils/classes";
import { c, stylex } from "~/utils/styles";
import { Spacer } from "./Space";

export const APP_PROMOTION_DISMISSED = "app_promotion_dismissed";

export const SpoofWarning = () => {
	const spoofedEmail = () => ADMIN_STATE().spoofedEmail.value;

	return (
		<Portal mount={document.body}>
			<Show when={!isNil(spoofedEmail())}>
				<div
					use:onClick={() => {
						quick((s) => {
							s.adminState.spoofUser(null);
							window.location.reload();
						});
					}}
					class={clsx("fixed  z-2000 bottom-0 right-0 cursor-pointer")}
					id="mobile-app-promotion"
				>
					<div
						class={clsx(" bg-gray-94 rounded relative p-8  column mr-4 mb-4 row items-center")}
						style={stylex(c.shadow(0, 10, 60, 0, c.hsl(0, 0, 0, 50)))}
					>
						<i class="fas fa-warning text-xl text-red-50" />
						<Spacer width={12} />
						<p class="font-semibold text-gray-10">Spoofing user {spoofedEmail()}</p>
					</div>
				</div>
			</Show>
		</Portal>
	);
};
